import React from 'react';
// import { useToast } from '@/hooks/use-toast';

const PersonalInfoForm = () => {
//   const { toast } = useToast();
  const [formData, setFormData] = React.useState({
    firstName: '',
    lastName: '',
    email: '',
    address: '',
    personalDetails1: '',
    personalDetails2: '',
    confirmDetails: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // toast({
    //   title: "Form submitted",
    //   description: "Your personal information has been updated."
    // });
  };

  return (
    <div className="p-6 max-w-4xl w-full">
      <h2 className="text-xl font-medium mb-6">Të dhënat personale</h2>

      <form onSubmit={handleSubmit}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
          <div>
            <label htmlFor="firstName" className="block text-sm mb-1">Emri</label>
            <input
              id="firstName"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              placeholder="Emri"
              className="w-full border border-[#000000]  px-3 py-2"
            />
          </div>
          <div>
            <label htmlFor="lastName" className="block text-sm mb-1">Mbiemri</label>
            <input
              id="lastName"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              placeholder="Mbiemri"
              className="w-full border border-[#000000]  px-3 py-2"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
          <div>
            <label htmlFor="email" className="block text-sm mb-1">Email</label>
            <input
              id="email"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="email@gmail.com"
              className="w-full border border-[#000000]  px-3 py-2"
            />
          </div>
          <div>
            <label htmlFor="address" className="block text-sm mb-1">Adresa</label>
            <input
              id="address"
              name="address"
              value={formData.address}
              onChange={handleChange}
              placeholder="0216, Lorem ipsum"
              className="w-full border border-[#000000]  px-3 py-2"
            />
          </div>
        </div>

        <div className="mb-6">
          <label className="block text-sm mb-2">Ndrysho fjalëkalimin</label>
          <div className="space-y-3">
            <input
              name="personalDetails1"
              value={formData.personalDetails1}
              onChange={handleChange}
              placeholder="Fjalëkalimi aktual"
              className="w-full border border-[#000000]  px-3 py-2"
            />
            <input
              name="personalDetails2"
              value={formData.personalDetails2}
              onChange={handleChange}
              placeholder="Fjalëkalimi i ri"
              className="w-full border border-[#000000]  px-3 py-2"
            />
            <input
              name="confirmDetails"
              value={formData.confirmDetails}
              onChange={handleChange}
              placeholder="Konfirmo fjalëkalimin"
              className="w-full border border-[#000000]  px-3 py-2"
            />
          </div>
        </div>

        <div className="flex justify-end gap-3">
          <button 
            type="button" 
            className="px-4 py-2 border border-[#000000]  hover:bg-gray-100 transition-colors"
          >
            Cancel
          </button>
          <button 
            type="submit" 
            className="px-4 py-2 bg-black text-white  hover:bg-gray-800 transition-colors"
          >
            Ruaj
          </button>
        </div>
      </form>
    </div>
  );
};

export default PersonalInfoForm;
